import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SUPERUSER, USER_STATE_KEY } from '../user.constants';
import * as userState from './user.reducer';

export const userSelector = createFeatureSelector<userState.IUserState>(USER_STATE_KEY);

export const user = createSelector(
  userSelector,
  userState.user
);

export const superuser = createSelector(
  user,
  (userObj): boolean => {
    return userObj.app_role === SUPERUSER;
  }
);
